/**
 * src/lib/download.js — hand bytes to the browser as a file.
 *
 * ⚠ ONE PLACE, because the alternative is each caller inventing its own
 * anchor-click dance and one of them forgetting to revoke the object URL.
 *
 * ⛔ The revoke is deferred, not immediate: Safari reads the href on a later
 * tick and revoking synchronously produces a silent no-op download.
 */
export function downloadBytes(bytes, fileName, mime) {
  if (typeof window === 'undefined' || typeof document === 'undefined') return false;
  try {
    const blob = new Blob([bytes], { type: mime || 'application/octet-stream' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
      try { URL.revokeObjectURL(url); } catch (_) { /* already gone */ }
      if (a.parentNode) a.parentNode.removeChild(a);
    }, 2000);
    return true;
  } catch (_) {
    return false;
  }
}
